<template>
    <div class="quiz-progress">
        <div class="quiz-progress__container">
            <span class="quiz-progress__indicator" :style="{ width: `${progress}%`, transition: 'width 0.5s ease-out' }"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'quiz-progress',
    props: {
        progress: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style lang="scss" scoped>
.quiz-progress {
    &__container {
        width: 100%;
        height: 18px;
        background: $concrete;
        border-radius: 40px;
        position: relative;
    }

    &__indicator {
        position: absolute;
        height: 18px;
        background: $amber;
        border-radius: 40px;
    }
}


</style>
